var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRejected = function SvgRejected(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EF4444",
    d: "M8 1.043c-3.921 0-7.111 3.19-7.111 7.111s3.19 7.111 7.11 7.111c3.922 0 7.112-3.19 7.112-7.11 0-3.922-3.19-7.112-7.111-7.112m2.915 9.084a.667.667 0 0 1-.942.943L8 9.097 6.026 11.07a.665.665 0 0 1-.942 0 .667.667 0 0 1 0-.943l1.974-1.973-1.974-1.973a.667.667 0 1 1 .943-.943L8.001 7.21l1.973-1.973a.667.667 0 1 1 .943.943L8.944 8.154l1.973 1.973z"
  })));
};
export default SvgRejected;